import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Globe, FileText, Clock, LanguagesIcon, CloudCog, Search, Bell } from "lucide-react";
export const ProblemSolution = () => {
  const {
    t
  } = useTranslation("landing");
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const iconClass = "h-12 w-12 text-primary mb-4";
  return <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Solution Section */}
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }}>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-br from-[#1A1F2C] to-[#2D1A43] bg-clip-text text-transparent">{t("solution.title")}</h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
          <motion.div className="bg-blue-50 p-6 rounded-xl border border-blue-100" variants={itemVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }}>
            <div className="bg-blue-100/50 p-4 inline-block rounded-lg mb-4">
              <CloudCog className={iconClass} />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">{t("solution.centralizedTitle")}</h3>
            <p className="text-gray-700">{t("solution.centralizedDesc")}</p>
          </motion.div>

          <motion.div className="bg-indigo-50 p-6 rounded-xl border border-indigo-100" variants={itemVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }}>
            <div className="bg-indigo-100/50 p-4 inline-block rounded-lg mb-4">
              <LanguagesIcon className={iconClass} />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">{t("solution.translationsTitle")}</h3>
            <p className="text-gray-700">{t("solution.translationsDesc")}</p>
          </motion.div>

          <motion.div className="bg-violet-50 p-6 rounded-xl border border-violet-100" variants={itemVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }}>
            <div className="bg-violet-100/50 p-4 inline-block rounded-lg mb-4">
              <Search className={iconClass} />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">{t("solution.materialsTitle")}</h3>
            <p className="text-gray-700">{t("solution.materialsDesc")}</p>
          </motion.div>
        </div>

        {/* Problem Section */}
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }}>
          
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <motion.div className="bg-purple-50 p-6 rounded-xl border border-purple-100" variants={itemVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }}>
            <div className="bg-purple-100/50 p-4 inline-block rounded-lg mb-4">
              <Clock className={iconClass} />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">{t("problem.lostTitle")}</h3>
            <p className="text-gray-700">{t("problem.lostDesc")}</p>
          </motion.div>

          <motion.div className="bg-purple-50 p-6 rounded-xl border border-purple-100" variants={itemVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }}>
            <div className="bg-purple-100/50 p-4 inline-block rounded-lg mb-4">
              <Globe className={iconClass} />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">{t("problem.complexityTitle")}</h3>
            <p className="text-gray-700">{t("problem.complexityDesc")}</p>
          </motion.div>

          <motion.div className="bg-purple-50 p-6 rounded-xl border border-purple-100" variants={itemVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }}>
            <div className="bg-purple-100/50 p-4 inline-block rounded-lg mb-4">
              <FileText className={iconClass} />
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-900">{t("problem.fragmentedTitle")}</h3>
            <p className="text-gray-700">{t("problem.fragmentedDesc")}</p>
          </motion.div>
        </div>
      </div>
    </section>;
};